import { colors } from '#/theme/theme';

export function highlightElement(element: HTMLElement) {
  const previousColor = element.style.backgroundColor;
  // oxlint-disable-next-line no-param-reassign
  element.style.transition = 'background-color 0.5s ease';
  // oxlint-disable-next-line no-param-reassign
  element.style.backgroundColor = colors.softBlue;

  setTimeout(() => {
    // oxlint-disable-next-line no-param-reassign
    element.style.backgroundColor = previousColor;
  }, 1000);
}
